import type { SOURCE_TYPE } from '@/types/feedbackConst';

export const getIntegrationQueryKeys = (
  source: SOURCE_TYPE,
  workspace_alias: string,
) => {
  return ['integration', source, workspace_alias];
};
